<h1 mat-dialog-title>Obter Imagem</h1>
<div
  mat-dialog-content
  align="center"
  [ngClass]="showWebcan || image ? 'main-large' : 'main-small'"
>
  <input
    accept="image/*"
    #uploadFileSelect
    (change)="upload($event)"
    type="file"
    style="display: none"
  />
  <webcam
    [height]="500"
    [width]="500"
    [trigger]="triggerObservable"
    (imageCapture)="handleImage($event)"
    *ngIf="showWebcan"
  ></webcam>
  <a *ngIf="image && !showWebcan" [href]="image" 
  target="_blank" rel="noopener noreferrer" aria-label="Abrir imagem em nova aba">
    <img
      height="375px"
      width="500px"
      [src]="image"
      style="cursor: pointer"
      alt="Imagem selecionada"
    />
  </a>
  <div class="buttons-section">
    <button
      mat-fab
      cdkFocusInitial
      (click)="findImage()"
      style="margin-right: 8px"
    >
      <mat-icon>image_search</mat-icon>
    </button>
    <button
      mat-fab
      cdkFocusInitial
      (click)="toggleCamera()"
      style="margin-right: 8px"
    >
      <mat-icon>camera_alt</mat-icon>
    </button>
    
    <button
      mat-fab
      cdkFocusInitial
      (click)="triggerSnapshot()"
      *ngIf="showWebcan"
    >
      <mat-icon>camera</mat-icon>
    </button>

  </div>
</div>
<div mat-dialog-actions align="end">
  <button color="warning" mat-button mat-dialog-close (click)="cancel()">
    CANCELAR
  </button>
  <button mat-button (click)="ok()" [disabled]="!image || imageFromInjected">OK</button>
</div>
